frappe.provide("erpnext.ui");

erpnext.ui.party_item_manager = class PartyItemManager {
	constructor(wrapper, frm, partyType) {
		this.wrapper = wrapper;
		this.frm = frm;
		this.partyType = partyType;
		this.doctype = "Party Specific Item";
		this.isPartyDoc = ["Customer", "Supplier"].includes(this.frm.doctype);
		this.restrictBasedOn = this.isPartyDoc ? "" : this.frm.doctype;

		this.setup();
	}

	setup() {
		const title = this.isPartyDoc
			? __("{0} restrictions", [__(this.partyType)])
			: __("Limited to {0}", [__(this.partyType).toLowerCase()]);

		this.wrapper.innerHTML = `
			<div class="party-specific-container">
				<div class="party-specific-header">
					<span class="header-title">${title}</span>
					<button class="btn btn-secondary btn-xs btn-add-party-specific">
						<i class="fa fa-plus"></i> ${__("Add")}
					</button>
				</div>
				<div class="party-specific-body"></div>
			</div>
		`;
		this.refresh();
		this.bindEvents();
	}

	async refresh() {
		const body = this.wrapper.querySelector(".party-specific-body");
		let filters = { party_type: this.partyType };

		if (this.isPartyDoc) {
			filters.party = this.frm.doc.name;
		} else {
			filters.restrict_based_on = this.restrictBasedOn;
			filters.based_on_value = this.frm.doc.name;
		}

		const entries = await frappe.db.get_list(this.doctype, {
			filters: filters,
			fields: ["name", "party", "restrict_based_on", "based_on_value"],
		});

		if (!entries.length) {
			body.innerHTML = `<div class="party-empty-state">${__("No restrictions defined.")}</div>`;
			return;
		}

		// Construction du tableau
		let html = `
			<div class="party-table-row party-table-head">
				<div class="col-main">${__("ID / Name")}</div>
				<div class="col-type">${__("Type")}</div>
				<div class="col-actions"></div>
			</div>
		`;

		entries.forEach((row) => {
			const mainValue = this.isPartyDoc ? row.based_on_value : row.party;
			const typeLabel = this.isPartyDoc ? row.restrict_based_on : this.partyType;

			html += `
				<div class="party-table-row party-data-row">
					<div class="col-main">
						<a class="party-id-link" data-type="${typeLabel}" data-name="${mainValue}">
							${mainValue}
						</a>
					</div>
					<div class="col-type">
						<span class="pill-type">${__(typeLabel)}</span>
					</div>
					<div class="col-actions">
						<button class="btn btn-xs btn-ghost btn-delete-row btn-remove-party-specific" data-docname="${
							row.name
						}" title="${__("Delete")}">
							${frappe.utils.icon("trash", "sm")}
						</button>
					</div>
				</div>
			`;
		});

		body.innerHTML = html;
		this.bindRowEvents();
	}

	bindRowEvents() {
		// Gestion des clics sur les liens
		this.wrapper.querySelectorAll(".party-id-link").forEach((link) => {
			link.onclick = (e) => {
				const { type, name } = e.target.dataset;
				frappe.set_route("Form", type, name);
			};
		});
	}

	bindEvents() {
		this.wrapper.querySelector(".btn-add-party-specific").onclick = () => this.addRow();
		this.wrapper.onclick = (e) => {
			const btn = e.target.closest(".btn-remove-party-specific");
			if (btn) this.removeRow(btn.dataset.docname);
		};
	}

	addRow() {
		if (this.frm.is_new()) {
			frappe.msgprint(__("Please save the document first."));
			return;
		}

		let fields = [];
		if (this.isPartyDoc) {
			fields = [
				{
					label: __("Restrict Based On"),
					fieldname: "restrict_based_on",
					fieldtype: "Select",
					options: ["Item", "Item Group", "Brand"],
					default: "Item",
					reqd: 1,
				},
				{
					label: __("Value"),
					fieldname: "based_on_value",
					fieldtype: "Dynamic Link",
					options: "restrict_based_on",
					reqd: 1,
				},
			];
		} else {
			fields = [
				{
					label: __(this.partyType),
					fieldname: "party",
					fieldtype: "Link",
					options: this.partyType,
					reqd: 1,
				},
			];
		}

		const d = new frappe.ui.Dialog({
			title: __("Add Restriction"),
			fields: fields,
			primary_action_label: __("Add"),
			primary_action: async (values) => {
				const doc = {
					doctype: this.doctype,
					party_type: this.partyType,
					party: this.isPartyDoc ? this.frm.doc.name : values.party,
					restrict_based_on: this.isPartyDoc ? values.restrict_based_on : this.restrictBasedOn,
					based_on_value: this.isPartyDoc ? values.based_on_value : this.frm.doc.name,
				};

				await frappe.call({ method: "frappe.client.insert", args: { doc } });
				await this.refresh();
				d.hide();
			},
		});
		d.show();
	}

	async removeRow(docname) {
		frappe.confirm(__("Remove this restriction?"), async () => {
			await frappe.call({
				method: "frappe.client.delete",
				args: { doctype: this.doctype, name: docname },
			});
			await this.refresh();
		});
	}
};
